import React, { Component } from "react";
import { FlexBox } from "js/react/components/LayoutGrid";
import { Icon, InputAdornment, TextField } from "@material-ui/core";
import styled from "styled-components";
import { Gap10, Gap30 } from "js/react/components/Gap";
import { themeColors } from "js/react/sharedStyles";
import { InviteSuggestions } from "js/react/components/InviteInput/InviteSuggestions";
import { Key } from "js/core/utilities/keys";

const SelectableProfile = styled.div`
  padding: 10px;
  width: 100%;
  &:hover {
    background: ${themeColors.lightBlue};
   }
`;

const FilterInput = styled(TextField)`
  .MuiOutlinedInput-adornedEnd {
    padding-right: 8px;
  }
  .MuiIcon-root {
    opacity: 0.33;
    cursor: pointer;
  }
`;

export class TeamMemberFilterableList extends Component {
    state = {
        filter: ""
    }

    handleKeyDown = event => {
        const {
            inviteContext,
            onSelect,
        } = this.props;

        switch (event.keyCode) {
            case Key.ENTER:
            case Key.UP_ARROW:
            case Key.DOWN_ARROW:
                // Prevent further events
                event.nativeEvent.stopImmediatePropagation();
                event.nativeEvent.preventDefault();

                switch (event.keyCode) {
                    case Key.ENTER:
                        let item = inviteContext.selectPendingSelection();
                        item && onSelect && onSelect(item);
                        break;
                    case Key.UP_ARROW:
                        inviteContext.pendingSelectPrev();
                        break;
                    case Key.DOWN_ARROW:
                        inviteContext.pendingSelectNext();
                        break;
                }
                break;
        }
    }

    handleChangeFilter = event => {
        let { inviteContext } = this.props;
        inviteContext.setFilter(event.target.value);
    }

    handleClearFilter = () => {
        let { inviteContext } = this.props;
        inviteContext.setFilter("");
    }

    render() {
        let {
            inviteContext,
            placeholder,
            onSelect,
        } = this.props;

        return (
            <FlexBox vertical left top fill>
                <FilterInput
                    id="filter"
                    fullWidth
                    value={inviteContext.filter}
                    onKeyDown={this.handleKeyDown}
                    onChange={this.handleChangeFilter}
                    variant="outlined"
                    placeholder={placeholder}
                    autoFocus
                    autoComplete="off"
                    InputProps ={{
                        endAdornment: (
                            <InputAdornment>
                                <Icon onClick={this.handleClearFilter}>close</Icon>
                            </InputAdornment>
                        )
                    }}
                />

                <Gap10/>

                <InviteSuggestions
                    inviteContext={inviteContext}
                    onSelect={onSelect}
                    sourceName="ManageTeamFolderMembersDialog"
                />
            </FlexBox>
        );
    }
}
